import { DeepLClient } from 'services/DeepLClient'

export const postTranslation = (text: string, targetLanguage: string) => {
    return DeepLClient.post('/v1/en/translate', {
        text,
        target_lang: targetLanguage,
    })
}
